import React from 'react'

const formatStr = (str, postItemMini) => {
	if (!str || typeof str !== 'string') {
		return ''
	}
	
	const size = postItemMini ? 50 : 300
	const newStr = str.replace(/<(?:.|\n)*?>/gm, '').substr(0, size)
	return `${newStr.substr(0, Math.min(newStr.length, newStr.lastIndexOf(" ")))}...`
}

const SearchItemExcerpt = ({postItem, postItemMini}) => {
	// Validation robuste des props
	if (!postItem || typeof postItem !== 'object') {
		return null
	}

	try {
		// Priorité 1: highlight.post_excerpt
		if (postItem.highlight && postItem.highlight.post_excerpt) {
			return (
				<p
					className={`search-list-item-description ${postItemMini ? 'search-list-mini-item-description' : ''}`}
					dangerouslySetInnerHTML={{ __html: postItem.highlight.post_excerpt }}
					role="text"
					aria-label="Extrait de l'article surligné"
				/>
			)
		}

		// Priorité 2: _source.post_excerpt
		if (postItem._source && postItem._source.post_excerpt) {
			return (
				<p
					className={`search-list-item-description ${postItemMini ? 'search-list-mini-item-description' : ''}`}
					dangerouslySetInnerHTML={{ __html: formatStr(postItem._source.post_excerpt, postItemMini) }}
					role="text"
					aria-label="Extrait de l'article"
				/>
			)
		}

		// Priorité 3: _source.post_content_filtered
		if (postItem._source && postItem._source.post_content_filtered) {
			return (
				<p
					className={`search-list-item-description ${postItemMini ? 'search-list-mini-item-description' : ''}`}
					dangerouslySetInnerHTML={{ __html: formatStr(postItem._source.post_content_filtered, postItemMini) }}
					role="text"
					aria-label="Contenu filtré de l'article"
				/>
			)
		}

		// Aucun contenu disponible
		return null
	} catch (error) {
		// Gestion gracieuse des erreurs
		console.warn('Erreur lors de la récupération de l\'extrait:', error)
		return null
	}
}

export default SearchItemExcerpt